import Vue from 'vue'
import Router from 'vue-router'

import index from '@/components/index'
import Register from '@/components/Register'
import ToForgetPwd from '@/components/ToForgetPwd'
import ChangePwd from '@/components/ChangePwd'

// 微信端页面
import WxUserInfo from '@/components/weChat/WxUserInfo'
import WxMyborrow from '@/components/weChat/WxMyborrow'
import WxMyloan from '@/components/weChat/WxMyloan'
import WxMyAssignmentDebt from '@/components/weChat/WxMyAssignmentDebt'
import WxMyPassword from '@/components/weChat/WxMyPassword'
import WxmyQRCode from '@/components/weChat/WxmyQRCode'
import WxCompleteInfo from '@/components/weChat/WxCompleteInfo'
import WxLogin from '@/components/weChat/WxLogin'
import WxForgetPassword from '@/components/weChat/WxForgetPassword'
import WxChangePwd from '@/components/weChat/WxChangePwd'
import WxMyBorrowProject from '@/components/weChat/WxMyBorrowProject'
import WxMyBorrowProjectDetail from '@/components/weChat/WxMyBorrowProjectDetail'
import WxMyHomePage from '@/components/weChat/WxMyHomePage'
import WxAssignmentDebtSharing from '@/components/weChat/WxAssignmentDebtSharing'
import WxBorrowProjectSharing from '@/components/weChat/WxBorrowProjectSharing'
import WxLoanProjectSharing from '@/components/weChat/WxLoanProjectSharing'
import WxProjectList from '@/components/weChat/WxProjectList'
import WxBorrowProjectDetail from '@/components/weChat/WxBorrowProjectDetail'
import WxLoanProjectDetail from '@/components/weChat/WxLoanProjectDetail'
import WxAssignmentDebtDetail from '@/components/weChat/WxAssignmentDebtDetail'
import WxMyCustomer from '@/components/weChat/WxMyCustomer'

// 微信公众号链接页面测试
import WxOfficialAccountTest from '@/components/weChat/WxOfficialAccountTest'
import WxError from '@/components/weChat/WxError'



// 内容管理-中心概况
// 中心简介
import CenterIntroduce from '@/components/contentManagement/centerSituation/centerIntroduce'
// 服务范围
import ServiceScope from '@/components/contentManagement/centerSituation/serviceScope'
// 经营宗旨
import ManagementAim from '@/components/contentManagement/centerSituation/managementAim'
// 组织架构
import OrganizationalStructure from '@/components/contentManagement/centerSituation/organizationalStructure'
// 平台优势
import PlatformAdvantage from '@/components/contentManagement/centerSituation/platformAdvantage'

// 业务流程-借贷流程
import BorrowProcess from '@/components/contentManagement/businessSituation/borrowProcess'
// 业务流程-债权转让流程
import DebtTransferProcess from '@/components/contentManagement/businessSituation/debtTransferProcess'
// 股权/资金投资流程
import EcInvestmentProcess from '@/components/contentManagement/businessSituation/ecInvestmentProcess'
// 资料下载
import DataDownload from '@/components/contentManagement/businessSituation/dataDownload'

// 借贷大厅：
import BorrowProject from '@/components/projectManagement/BorrowProject'
import LoanProject from '@/components/projectManagement/LoanProject'
import AssignmentDebt from '@/components/projectManagement/AssignmentDebt'
import BorrowProjectDetail from '@/components/projectManagement/BorrowProjectDetail'
import LoanProjectDetail from '@/components/projectManagement/LoanProjectDetail'
import AssignmentDebtDetail from '@/components/projectManagement/AssignmentDebtDetail'
// 内容管理-政策法规
// 政策法规
import PoliciesRegulations from '@/components/contentManagement/policiesRegulations/PoliciesRegulations'
import PoliciesRegulationsDetail from '@/components/contentManagement/policiesRegulations/PoliciesRegulationsDetail'
// 借贷知识
import BorrowingKnowledge from '@/components/contentManagement/policiesRegulations/BorrowingKnowledge'
import BorrowingKnowledgeDetail from '@/components/contentManagement/policiesRegulations/BorrowingKnowledgeDetail'

// 股权/基金投资-股权/基金投资介绍
import EcInvestmentIntroduction from '@/components/contentManagement/ecInvestment/ecInvestmentIntroduction'
// 股权/基金投资项目
import EfInvestmentProject from '@/components/contentManagement/ecInvestment/efInvestmentProject/EfInvestmentProject'
import EfInvestmentProjectDetail from '@/components/contentManagement/ecInvestment/efInvestmentProject/EfInvestmentProjectDetail'
// 股权/基金投资-成功案例
import SuccessfulCase from '@/components/contentManagement/ecInvestment/successfulCase'

// 其他页面-合作伙伴
import CooperativePartner from '@/components/contentManagement/otherPage/cooperativePartner'
// 其他页面-法律申明
import LawStatement from '@/components/contentManagement/otherPage/lawStatement'
// 其他页面-招贤纳士
import Recruitment from '@/components/contentManagement/otherPage/recruitment'
// 其他页面-联系我们
import ContactUs from '@/components/contentManagement/otherPage/contactUs'
// 其他页面-中心问答
import CenterAnswer from '@/components/contentManagement/otherPage/centerAnswer'

// 咨询中心
// 通知公告
import NotificationAnnouncement from '@/components/contentManagement/referenceCenter/notificationAnnouncement/NotificationAnnouncement'
import NotificationAnnouncementDetail from '@/components/contentManagement/referenceCenter/notificationAnnouncement/NotificationAnnouncementDetail'
// 中心新闻
import CenterNews from '@/components/contentManagement/referenceCenter/centerNews/CenterNews'
import CenterNewsDetail from '@/components/contentManagement/referenceCenter/centerNews/CenterNewsDetail'
// 行业资讯
import IndustryInformation from '@/components/contentManagement/referenceCenter/industryInformation/IndustryInformation'
import IndustryInformationDetail from '@/components/contentManagement/referenceCenter/industryInformation/IndustryInformationDetail'
// 投资快报
import InvestmentExpress from '@/components/contentManagement/referenceCenter/investmentExpress/InvestmentExpress'
import InvestmentExpressDetail from '@/components/contentManagement/referenceCenter/investmentExpress/InvestmentExpressDetail'
// 交流合作
import CommunicationCooperation from '@/components/contentManagement/referenceCenter/communicationCooperation/CommunicationCooperation'
import CommunicationCooperationDetail from '@/components/contentManagement/referenceCenter/communicationCooperation/CommunicationCooperationDetail'
// 案例展示
import CaseShow from '@/components/contentManagement/referenceCenter/caseShow/CaseShow'
import CaseShowDetail from '@/components/contentManagement/referenceCenter/caseShow/CaseShowDetail'


// 用户中心-个人中心
import PersonalInformation from '@/components/userCenter/PersonalInformation'
// 用户中心-修改密码
import PasswordEdit from '@/components/userCenter/PasswordEdit'
// 用户中心-我的借贷
import MyBorrow from '@/components/userCenter/MyBorrow'
import MyBorrowPage from '@/components/userCenter/MyBorrowPage'
import MyLoanPage from '@/components/userCenter/MyLoanPage'
import MyLoanIntentionPage from '@/components/userCenter/MyLoanIntentionPage'
import MyBorrowIntentionPage from '@/components/userCenter/MyBorrowIntentionPage'
import MyAssignmentDebtIntentionPage from '@/components/userCenter/MyAssignmentDebtIntentionPage'
import MyAssignmentDebtPage from '@/components/userCenter/MyAssignmentDebtPage'

import {reqGetWebUserById} from '../api/system-api';

const Login = resolve => require(['@/components/Login'], resolve);

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'index',
        component: index
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
// 忘记密码，找回密码：
    {
        path: '/toForgetPwd',
        name: 'toForgetPwd',
        component: ToForgetPwd
    },
// 重置密码：
    {
        path: '/changePwd',
        name: 'changePwd',
        component: ChangePwd
    },
// 内容管理：
// 中心简介
    {
        path: '/centerIntroduce',
        name: 'centerIntroduce',
        component: CenterIntroduce
    },
// 服务范围
    {
        path: '/serviceScope',
        name: 'serviceScope',
        component: ServiceScope
    },
// 经营宗旨
    {
        path: '/managementAim',
        name: 'managementAim',
        component: ManagementAim
    },
// 组织架构
    {
        path: '/organizationalStructure',
        name: 'organizationalStructure',
        component: OrganizationalStructure
    },
//平台优势
{
        path: '/platformAdvantage',
        name: 'platformAdvantage',
        component: PlatformAdvantage
},

    // 业务流程-借贷流程
    {path:'/borrowProcess', name:'borrowProcess', component:BorrowProcess},
    // 债权转让流程
    {path:'/debtTransferProcess', name:'debtTransferProcess', component:DebtTransferProcess},
    // 股权/基金投资流程
    {path:'/ecInvestmentProcess', name:'ecInvestmentProcess', component:EcInvestmentProcess},
    // 资料下载
    {path:'/dataDownload', name:'dataDownload', component:DataDownload},

// 借贷大厅：
    {path:'/borrowProject', name:'borrowProject', component:BorrowProject},
    {path:'/loanProject', name:'loanProject', component:LoanProject},
    {path:'/assignmentDebt', name:'assignmentDebt', component:AssignmentDebt},
    {path:'/borrowProjectDetail', name:'borrowProjectDetail', component:BorrowProjectDetail},
    {path:'/loanProjectDetail', name:'loanProjectDetail', component:LoanProjectDetail},
    {path:'/assignmentDebtDetail', name:'assignmentDebtDetail', component:AssignmentDebtDetail},
// 内容管理：
// 政策法规-政策法规
    {
        path: '/policiesRegulations',
        name: 'policiesRegulations',
        component: PoliciesRegulations
    },
    {
        path: '/policiesRegulationsDetail',
        name: 'policiesRegulationsDetail',
        component: PoliciesRegulationsDetail
    },
    // 借贷知识
    {
        path: '/borrowingKnowledge',
        name: 'borrowingKnowledge',
        component: BorrowingKnowledge
    },
    {
        path: '/borrowingKnowledgeDetail',
        name: 'borrowingKnowledgeDetail',
        component: BorrowingKnowledgeDetail
    },

    // 股权/基金投资-股权/基金投资介绍
    {
        path: '/ecInvestmentIntroduction',
        name: 'ecInvestmentIntroduction',
        component: EcInvestmentIntroduction
    },
    // 股权/基金投资-股权/基金投资项目
    {
        path: '/efInvestmentProject',
        name: 'efInvestmentProject',
        component: EfInvestmentProject
    },
    {
        path: '/efInvestmentProjectDetail',
        name: 'efInvestmentProjectDetail',
        component: EfInvestmentProjectDetail
    },
    // 股权/基金投资-成功案例
    {
        path: '/successfulCase',
        name: 'successfulCase',
        component: SuccessfulCase
    },
    // 其他页面-合作伙伴
    {
        path: '/cooperativePartner',
        name: 'cooperativePartner',
        component: CooperativePartner
    },
    // 其他页面-法律申明
    {
        path: '/lawStatement',
        name: 'lawStatement',
        component: LawStatement
    },
    // 其他页面-招贤纳士
    {
        path: '/recruitment',
        name: 'recruitment',
        component: Recruitment
    },
    // 其他页面-联系我们
    {
        path: '/contactUs',
        name: 'contactUs',
        component: ContactUs
    },
// 其他页面-中心问答
  {
    path: '/centerAnswer',
    name: 'centerAnswer',
    component: CenterAnswer
  },
// 咨询中心
// 通知公告
    {
        path: '/notificationAnnouncement',
        name: 'notificationAnnouncement',
        component: NotificationAnnouncement
    },
    {
        path: '/notificationAnnouncementDetail',
        name: 'notificationAnnouncementDetail',
        component: NotificationAnnouncementDetail
    },
    // 中心新闻
    {
        path: '/centerNews',
        name: 'centerNews',
        component: CenterNews
    },
    {
        path: '/centerNewsDetail',
        name: 'centerNewsDetail',
        component: CenterNewsDetail
    },
    // 行业资讯
    {
        path: '/industryInformation',
        name: 'industryInformation',
        component: IndustryInformation
    },
    {
        path: '/industryInformationDetail',
        name: 'industryInformationDetail',
        component: IndustryInformationDetail
    },
    // 投资快讯
    {
        path: '/investmentExpress',
        name: 'investmentExpress',
        component: InvestmentExpress
    },
    {
        path: '/investmentExpressDetail',
        name: 'investmentExpressDetail',
        component: InvestmentExpressDetail
    },
    // 交流合作
    {
        path: '/communicationCooperation',
        name: 'communicationCooperation',
        component: CommunicationCooperation
    },
    {
        path: '/communicationCooperationDetail',
        name: 'communicationCooperationDetail',
        component: CommunicationCooperationDetail
    },
    // 案例展示
    {
        path: '/caseShow',
        name: 'caseShow',
        component: CaseShow
    },

    {
        path: '/caseShowDetail',
        name: 'caseShowDetail',
        component: CaseShowDetail
    },
    // 用户中心-个人信息
    {
        path: '/personalInformation',
        name: 'personalInformation',
        component: PersonalInformation
    },

    // 用户中心-修改密码
    {
        path: '/passwordEdit',
        name: 'passwordEdit',
        component: PasswordEdit
    },
    // 用户中心-我的借贷
    {
        path: '/myBorrow',
        name: 'myBorrow',
        component: MyBorrow
    },
    {
        path: '/myBorrowIntentionPage',
        name: 'myBorrowIntentionPage',
        component: MyBorrowIntentionPage
    },
    {
        path: '/myLoanIntentionPage',
        name: 'myLoanIntentionPage',
        component: MyLoanIntentionPage
    },
    {
        path: '/myBorrowPage',
        name: 'myBorrowPage',
        component: MyBorrowPage
    },
  {
    path: '/myLoanPage',
    name: 'myLoanPage',
    component: MyLoanPage
  },
  {
    path: '/myAssignmentDebtPage',
    name: 'myAssignmentDebtPage',
    component: MyAssignmentDebtPage
  },
  {
    path: '/myAssignmentDebtIntentionPage',
    name: 'myAssignmentDebtIntentionPage',
    component: MyAssignmentDebtIntentionPage
  },

// 微信端页面路由
    {
        path: '/wxuserInfo',
        name: 'wxuserInfo',
        component: WxUserInfo
    },
    {
        path: '/wxmyborrow',
        name: 'wxmyborrow',
        component: WxMyborrow
    },
    {
        path: '/wxmyloan',
        name: 'wxmyloan',
        component: WxMyloan
    },
    {
        path: '/wxmyAssignmentDebt',
        name: 'wxmyAssignmentDebt',
        component: WxMyAssignmentDebt
    },

    {
        path: '/wxmyPassword',
        name: 'wxmyPassword',
        component: WxMyPassword
    },
    {
        path: '/wxmyQRCode',
        name: 'wxmyQRCode',
        component: WxmyQRCode
    },
    {
        path: '/mp',
        name: 'mp',
        component: WxCompleteInfo
    },
    {
        path: '/wxLogin',
        name: 'wxLogin',
        component: WxLogin
    },
    {
        path: '/wxForgetPassword',
        name: 'wxForgetPassword',
        component: WxForgetPassword
    },
    {
        path: '/wxChangePwd',
        name: 'wxChangePwd',
        component: WxChangePwd
    },
    {
        path: '/wxMyHomePage',
        name: 'wxMyHomePage',
        component: WxMyHomePage
    },
// 借贷大厅我的借入项目
    {
        path: '/wxMyBorrowProject',
        name: 'wxMyBorrowProject',
        component: WxMyBorrowProject
    },
    {
        path: '/wxMyBorrowProjectDetail',
        name: 'wxMyBorrowProjectDetail',
        component: WxMyBorrowProjectDetail
    },
    {
      path: '/wxAssignmentDebtSharing',
      name: 'wxAssignmentDebtSharing',
      component: WxAssignmentDebtSharing
    },
    {
      path: '/wxBorrowProjectSharing',
      name: 'wxBorrowProjectSharing',
      component: WxBorrowProjectSharing
    },
    {
      path: '/wxLoanProjectSharing',
      name: 'wxLoanProjectSharing',
      component: WxLoanProjectSharing
    },
    {
      path: '/wxProjectList',
      name: 'wxProjectList',
      component: WxProjectList
    },
    {
      path: '/wxBorrowProjectDetail',
      name: 'wxBorrowProjectDetail',
      component: WxBorrowProjectDetail
    },
    {
      path: '/wxLoanProjectDetail',
      name: 'wxLoanProjectDetail',
      component: WxLoanProjectDetail
    },
    {
      path: '/wxAssignmentDebtDetail',
      name: 'wxAssignmentDebtDetail',
      component: WxAssignmentDebtDetail
    },

  {
    path: '/wxMyCustomer',
    name: 'wxMyCustomer',
    component: WxMyCustomer
  },
  // 微信公众号链接页面跳转测试
  {
    path: '/wxOfficialAccountTest',
    name: 'wxOfficialAccountTest',
    component: WxOfficialAccountTest
  },

    {
      path: '/wxError',
      name: 'wxError',
      component: WxError
    },

];

// 需要进行登录验证路由
let permissionValidation=[
  // 'createProject01',
  // 'weChat'
]

let router = new Router({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/login')) {
    sessionStorage.removeItem('access-user');
    next()
  } else if (permissionValidation.indexOf(to.name)!==-1) {
    let user = JSON.parse(sessionStorage.getItem('access-user'));
    if (!user) {
      if(to.query.u){
        var u=to.query.u;

        // console.log(this, this.a.app)
        reqGetWebUserById({id:u}).then((res)=> {
          if(res.data.status===1){
            sessionStorage.setItem('access-user', JSON.stringify(res.data.data));
            next();
          } else {
            next({path: '/login', query: {redirect : to.fullPath}});
          }
         });
      }else {
        next({path: '/login', query: {redirect : to.fullPath}})
      }
    } else {
      next()
    }
  } else{
    next()
  }
  // 百度统计
  if (to.path) {
    _hmt.push(['_trackPageview', to.fullPath]);
  }
  next();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js